<template>
  <div v-if="product">
    <!-- breadcrumb start -->
    <product-details-breadcrumb :product="product" />
    <!-- breadcrumb end -->

    <!-- product details area start -->
    <product-details-area :product="product" />
    <!-- product details area end -->

    <!-- related products start -->
    <product-related
      :relatedProducts="product.related"
      v-if="product.related.length"
    />
    <!-- related products end -->
  </div>
</template>

<script setup lang="ts">
import { useProductStore } from "@/pinia/useProductStore";
import { type IProduct } from "@/types/product-type";
import { useLoader } from "../../pinia/useLoader";

const route = useRoute();
const {} = useLoader();
const { stopLoading, startLoading } = useLoader();
//startLoading();

const { getProduct } = useProductStore();

const product = ref({});
product.value = (await getProduct(route.params.id)
  .then((res) => {
    //stopLoading();
    return res;
  })
  .catch((err) => {
    console.log(err);
  })) as IProduct;
const productTitle = computed(() => product.value?.name);
const productDescription = computed(() => product.value?.description);
const productImage = computed(() => product.value?.main_img?.full_url);

// onMounted(() => {
// useSeoMeta({
//   title: productTitle.value,
//   ogTitle: productTitle.value,
//   description: productDescription.value,
//   ogDescription: productDescription.value,
//   ogImage: productImage.value,
//   ogUrl: "https://swift-ecommerce.urusglobal.com" + route.path,
//   ogType: "website",
//   twitterCard: "summary_large_image",
//   twitterTitle: productTitle.value,
//   twitterDescription: productDescription.value,
//   twitterImage: productImage.value,
// });

useHead(() => ({
  title: productTitle.value,
  link: [
    {
      rel: "canonical",
      href: "https://swift-ecommerce.urusglobal.com" + route.path,
    },
  ],
  meta: [
    {
      name: "description",
      content: productDescription.value,
    },
    {
      property: "og:title",
      content: productTitle.value,
    },
    {
      property: "og:description",
      content: productDescription.value,
    },
    {
      property: "og:image",
      content: productImage.value,
    },
    {
      property: "og:url",
      content: "https://swift-ecommerce.urusglobal.com" + route.path,
    },
    {
      property: "og:type",
      content: "website",
    },
    {
      property: "twitter:card",
      content: "summary_large_image",
    },
    {
      property: "twitter:title",
      content: productTitle.value,
    },
    {
      property: "twitter:description",
      content: productDescription.value,
    },
    {
      property: "twitter:image",
      content: productImage.value,
    },
  ],
}));
// });
</script>
